import script from "./CheckoutCustomerDeliverable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutCustomerDeliverable.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutCustomerDeliverable.vue?vue&type=style&index=0&id=6f075442&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f075442"]])

export default __exports__